import React from 'react';
import Title from "../Title"
import StaticLiveSwitch, { ViewType } from './StaticLiveSwitch';
import { isMobile, isMobileOnly, useMobileOrientation } from 'react-device-detect';
import { Box, useTheme, useMediaQuery } from '@mui/material';

export default function Live(props) {

    const { contentHeight, camera: { image: imageSource = "", name: cameraName = "", video: videoSource = "" }, handleStaticLiveSwitch } = props
    const { isLandscape } = useMobileOrientation()
    const { breakpoints } = useTheme()

    const camCount = window.conf.CAMERAS.length
    const manyCams = camCount > window.conf.LAYOUT.WRAP_LIMIT
    const moreThanOneCamera = camCount > 1
    const isXl = useMediaQuery(breakpoints.up('xl'))
    const isMd = useMediaQuery(breakpoints.down('md'))

    return (
        <Box 
            className="live-view-container"
            sx={{
                display: "flex",
                justifyContent: "center",
                position: "relative"
            }}
        >
            <Title cameraName={cameraName} />
            
            {imageSource && <StaticLiveSwitch type={ViewType.Image} onClick={handleStaticLiveSwitch} />}

            <iframe
                allowFullScreen
                title={cameraName} 
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: isMobileOnly
                            ? isLandscape
                                ? contentHeight
                                : camCount < 2
                                    ? contentHeight
                                    : camCount < 3
                                        ? contentHeight/2
                                        : 'unset'
                            : manyCams
                                ? '100%'
                                : isXl && camCount > 2
                                    ? contentHeight/Math.ceil(camCount/3)
                                    : contentHeight/Math.ceil(camCount/2),
                    width: "100%",
                    border: "none"
                }}
                className={
                    isMobile
                    ? !isLandscape && camCount > 2
                        ? "responsive-iframe"
                        : ""
                    : camCount < 2
                        ? 'heightWithoutHeader'
                        : camCount === 2
                            ? 'halfHeightWithoutHeader'
                            : moreThanOneCamera && !isMobile && !isMd
                                ? manyCams 
                                    ? "responsive-iframe"
                                    : "unsetHeight" 
                                : 'responsive-iframe'
                }
                src={videoSource} 
            />
        </Box>
    )
}